module.exports = __webpack_public_path__ + "static/img/img11.15ad5e93.png";